export const TransactionFields  = [
  { id: 1, key : "txId", name: "TXID"},
  { id: 2, key : "txDate", name: "TX date/time"},
  { id: 25, key : "stripeStatus", name: "Stripe status" },
  { id: 26, key : "appointmentStatus", name: "Appointment Status" },
  { id: 3, key : "patientId", name: "Patient ID" },
  { id: 4, key : "patientName", name: "Patient name" },
  { id: 5, key : "healthcareProvider", name: "Healthcare provider" },
  { id: 6, key : "doctorId", name: "Doctor ID" },
  { id: 7, key : "doctorName", name: "Doctor name" },
  { id: 8, key : "repeatCodeType", name: "Repeat code type" },
  { id: 9, key : "repeatCode", name: "Repeat code" },
  { id: 10, key : "discount", name: "Discount (Rs.)" },
  { id: 11, key : "grossConsultationFee", name: "Gross consultation fee (Rs.)" },
  { id: 12, key : "netConsultationFee", name: "Net consultation fee (Rs.)" },
  { id: 13, key : "doctorFee", name: "Doctor fee (Rs.)" },
  { id: 14, key : "hospitalFee", name: "Hospital fee (Rs.)" },
  { id: 15, key : "convenienceFee", name: "Convenience fee (Rs.)" },
  { id: 16, key : "sscl", name: "SSCL (Rs.)" },
  { id: 17, key : "vat", name: "VAT (Rs.)" },
  { id: 18, key : "totalCollected", name: "Total collected (Rs.)" },
  { id: 19, key : "paymentGatewayFee", name: "PGateway fee (Rs.)" },
  { id: 20, key: "netConvenienceFee", name: "Net convenience fee (Rs.)" },
  { id: 21, key : "modeOfConsultation", name: "Mode of consultation" },
  { id: 22, key : "paymentMode", name: "Payment mode" },
  { id: 23, key : "locationName", name: "Location name" },
  { id: 24, key : "address", name: "Address" }
];
